import {
  Card,
  CardHeader,
  CardBody,
  Form,
  FormGroup,
  Label,
  Input,
  Container,
  Row,
  Col,
  Button,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import InfoPopover from "components/CommonComponents/InfoPopover";
import AdminHeader from "components/Headers/AdminHeader";
import React, { useContext, useEffect, useState } from "react";
import Select from "react-select";
import { SELECT_CUSTOM_STYLES, REGEX } from "constants/CommonConstants";
import { useDispatch, useSelector } from "react-redux";
import { getTraineeList } from "action/trainee";
import { traineeList } from "constants/trainee";
import {
  createLetter,
  getLetterTemplateContent,
  updateLetter,
  getLetterByID,
  requestLetterApproval,
  deleteLetterUser,
} from "action/letter";
import { NotificationContext } from "components/CommonComponents/NotificationProvider";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { urlDecodedId } from "components/CommonComponents/encodeDecodeFunction";
import {
  humanReadableToInputDate,
  showAlert,
} from "components/CommonComponents/CommonFunctions";
import {
  LETTER_FILTER_VALUES,
  LETTER_SCOPE_OPTIONS,
} from "components/constant";
import { deleteToolItems } from "action/letter";
import DatePicker from "react-datepicker";
import { format } from "date-fns";

const getInitialFields = () => ({
  letterType: {
    value: "AUTHORIZATION_LETTER",
    oldValue: "AUTHORIZATION_LETTER",
    error: "",
  },
  letterScopeType: {
    value: "INDIVIDUAL",
    oldValue: "INDIVIDUAL",
    error: "",
  },

  productCategory: {
    value: [],
    oldValue: [],
    error: "",
  },
  voltageClass: {
    value: [],
    oldValue: [],
    error: "",
  },
  termination: {
    value: [],
    oldValue: [],
    error: "",
  },
  pluginTermination: {
    value: [],
    oldValue: [],
    error: "",
  },
  joints: {
    value: [],
    oldValue: [],
    error: "",
  },
  natureOfWork: {
    value: [],
    oldValue: [],
    error: "",
  },
  agency: {
    value: "",
    oldValue: "",
    error: "",
  },
  project: {
    value: "",
    oldValue: "",
    error: "",
  },
  issuedToCustomer: {
    value: "",
    oldValue: "",
    error: "",
  },
  issueDate: {
    value: "",
    oldValue: "",
    error: "",
  },
  validTill: {
    value: "",
    oldValue: "",
    error: "",
  },
  fromLocation: {
    value: "",
    oldValue: "",
    error: "",
  },
  toLocation: {
    value: "",
    oldValue: "",
    error: "",
  },
  status: {
    value: "",
    oldValue: "",
    error: "",
  },
  rejectionReason: {
    value: "",
    oldValue: "",
    error: "",
  },
  jointers: [
    {
      name: { value: "", error: "" },
      validId: { value: "", error: "" },
      photo: { value: null, preview: "", error: "" },
      isEditing: true,
      isSupport: { value: "NO", error: "" },
    },
  ],
  tools: [
    {
      description: { value: "", error: "" },
      qty: { value: "", error: "" },
      isEditing: true,
    },
  ],
});

function LetterForm() {
  const authData = JSON.parse(localStorage.getItem("p") || "{}");
  const role = authData?.role;
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const pageMode = location.state?.mode || "add"; //add /edit
  const [mode, setMode] = useState(pageMode);
  const decodedId = id ? urlDecodedId(id) : null;
  const traineeDataList = useSelector((state) => state.trainees.traineeList);
  const templateContent = useSelector(
    (state) => state.letters?.letterTemplateContent,
  );
  const [letterData, setLetterData] = useState(getInitialFields());
  const [showLoaderOnClick, setShowLoaderOnClick] = useState(false);
  const { notify } = useContext(NotificationContext);
  const [previewModal, setPreviewModal] = useState({
    isOpen: false,
    fileUrl: "",
  });
  const [letterID, setLetterID] = useState("");
  const [deleteTracker, setDeleteTracker] = useState({
    users: [],
    photos: [],
  });

  // Prefill form when in edit mode
  useEffect(() => {
    if (decodedId) {
      fetchLetterDetails(decodedId);
      setLetterID(decodedId);
    }
  }, [decodedId]);

  const buildFilterParams = () => {
    const filterParams = [];

    filterParams.push({
      field: "Status",
      condition: "eq",
      filterValues: ["ACTIVE"],
    });
    return {
      filters: filterParams.length > 0 ? JSON.stringify(filterParams) : [],
    };
  };

  useEffect(() => {
    getTraineeList(dispatch, 0,
      buildFilterParams(),
    );
    return () => {
      dispatch({ type: traineeList, payload: {} });
    };
  }, [dispatch]);

  const fetchLetterDetails = async (idToFetch) => {
    const finalId = idToFetch || decodedId;

    if (!finalId) return;
    const res = await getLetterByID(finalId);

    if (res?.code === 200 && res?.data) {
      const data = res.data;

      setLetterData((prev) => ({
        ...prev,

        letterType: {
          value: data.letterType,
          oldValue: data.letterType,
          error: "",
        },

        letterScopeType: {
          value: data.letterScope,
          oldValue: data.letterScope,
          error: "",
        },

        issueDate: {
          value: humanReadableToInputDate(data.issueDate),
          oldValue: humanReadableToInputDate(data.issueDate),
          error: "",
        },

        validTill: {
          value: humanReadableToInputDate(data.validTill),
          oldValue: humanReadableToInputDate(data.validTill),
          error: "",
        },

        project: {
          value: data.project || "",
          oldValue: data.project || "",
          error: "",
        },

        issuedToCustomer: {
          value: data.issuedToCustomer || "",
          oldValue: data.issuedToCustomer || "",
          error: "",
        },

        fromLocation: {
          value: data.fromLocation || "",
          oldValue: data.fromLocation || "",
          error: "",
        },

        toLocation: {
          value: data.toLocation || "",
          oldValue: data.toLocation || "",
          error: "",
        },

        agency: {
          value: data.requestOf || "",
          oldValue: data.requestOf || "",
          error: "",
        },

        productCategory: {
          value: data.productCategory?.map((i) => i.id) || [],
          oldValue: data.productCategory?.map((i) => i.id) || [],
          error: "",
        },

        natureOfWork: {
          value: data.natureOfWork?.map((i) => i.id) || [],
          oldValue: data.natureOfWork?.map((i) => i.id) || [],
          error: "",
        },

        voltageClass: {
          value: data.voltageClass?.map((i) => i.id) || [],
          oldValue: data.voltageClass?.map((i) => i.id) || [],
          error: "",
        },

        termination: {
          value: data.termination?.map((i) => i.id) || [],
          oldValue: data.termination?.map((i) => i.id) || [],
          error: "",
        },

        pluginTermination: {
          value: data.plugInTermination?.map((i) => i.id) || [],
          oldValue: data.plugInTermination?.map((i) => i.id) || [],
          error: "",
        },

        status: {
          value: data.status || "",
          oldValue: data.status || "",
          error: "",
        },

        rejectionReason: {
          value: data.rejectionReason || "",
          oldValue: data.rejectionReason || "",
          error: "",
        },

        joints: {
          value: data.joints?.map((i) => i.id) || [],
          oldValue: data.joints?.map((i) => i.id) || [],
          error: "",
        },
        tools: data.tools?.length
          ? [
            ...data.tools.map((t) => ({
              description: {
                value: t.itemDescription || "",
                oldValue: t.itemDescription || "",
                error: "",
              },
              qty: {
                value: t.quantity || "",
                oldValue: t.quantity || "",
                error: "",
              },
              isEditing: false,
            })),
            {
              description: { value: "", error: "" },
              qty: { value: "", error: "" },
              isEditing: true,
            },
          ]
          : [
            {
              description: { value: "", error: "" },
              qty: { value: "", error: "" },
              isEditing: true,
            },
          ],
        jointers: (() => {
          const existingJointers =
            data.LetterUsers?.length > 0
              ? data.LetterUsers.map((user) => ({
                letterUserId: user.ID,
                name: {
                  value: {
                    userID: user.userID,
                    user: { fullName: user.name },
                  },
                  oldValue: {
                    userID: user.userID,
                    user: { fullName: user.name },
                  },
                  error: "",
                },
                validId: {
                  value: user.governmentID || "",
                  oldValue: user.governmentID || "",
                  error: "",
                },
                photo: {
                  value: null,
                  preview: user.userProfilePath || "",
                  error: "",
                },
                isEditing: false,
                isSupport: {
                  value: user.isSupport,
                  oldValue: user.isSupport,
                  error: "",
                },
              }))
              : [];

          const scope = data.letterScope;

          const isCableAccessory = data.productCategory?.some(
            (i) => i.contentValue === "Cable Accessories",
          );

          // if project/group allow multiple jointers
          // scope !== "PROJECT_FREE" condition added on 14 Apr as per new change request
          if (
            scope !== "INDIVIDUAL" &&
            scope !== "PROJECT_FREE" &&
            !isCableAccessory &&
            existingJointers.length < 3
          ) {
            existingJointers.push({
              name: { value: "", error: "" },
              validId: { value: "", error: "" },
              photo: { value: null, preview: "", error: "" },
              isEditing: true,
              isSupport: { value: "NO", error: "" },
            });
          }

          // fallback if no jointer exists
          return existingJointers.length > 0
            ? existingJointers
            : [
              {
                name: { value: "", error: "" },
                validId: { value: "", error: "" },
                photo: { value: null, preview: "", error: "" },
                isEditing: true,
              },
            ];
        })(),
      }));
    }
  };

  const getChangedFields = () => {
    const changed = {};

    Object.keys(letterData).forEach((key) => {
      if (key === "jointers") {
        const hasJointerChanges = letterData.jointers.some((j) => {
          const currentValue = JSON.stringify({
            userID: j?.name?.value?.userID,
            name: j?.name?.value?.user?.fullName,
            governmentID: j.validId.value,
            isSupport: j.isSupport.value,
          });

          const oldValue = JSON.stringify({
            userID: j.name.oldValue?.userID,
            name: j.name.oldValue?.user?.fullName,
            governmentID: j.validId.oldValue,
            isSupport: j.isSupport.oldValue,
          });

          const photoChanged = !!j.photo.value;

          return currentValue !== oldValue || photoChanged;
        });

        if (hasJointerChanges) {
          changed.jointers = letterData.jointers
            .filter((j) => j?.name?.value)
            .map((j) => ({
              id: j?.name?.value?.userID,
              name: j?.name?.value?.user?.fullName,
              governmentID: j.validId.value,
              isSupport: j.isSupport.value,
            }));
        }
        return;
      }

      if (Array.isArray(letterData[key])) return;

      const { value, oldValue } = letterData[key];

      const isDifferent = JSON.stringify(value) !== JSON.stringify(oldValue);

      if (isDifferent) {
        changed[key] = value;
      }
    });

    return changed;
  };

  const handleChange = (field, value) => {
    if (field === "issueDate") {
      setLetterData((prev) => ({
        ...prev,
        issueDate: {
          value,
          error: "",
        },
      }));

      return;
    }

    if (field === "productCategory") {
      const options = getOptionsByType("PRODUCT_CATEGORY");

      const cableAccessory = options.find(
        (opt) => opt.label === "Cable Accessories",
      );

      const isCableAccessory =
        cableAccessory && value.includes(cableAccessory.value);

      const scope = letterData.letterScopeType.value;
      // scope === "PROJECT_FREE" condition removed on 14 Apr as per new change request
      const isProject =
        scope === "PROJECT_PAID" ||
        letterData.letterType.value === "TOOL_LETTER"; // || scope === "PROJECT_FREE";

      if (isCableAccessory && isProject) {
        const selectedJointers = letterData.jointers.filter(
          (j) => j?.name?.value,
        );

        if (selectedJointers.length > 1) {
          showAlert({
            title: "Invalid Selection",
            message: `Only one jointer can be added for a letter with the product category "Cable Accessories". Please remove the existing jointers and keep only one jointer to continue.`,
            type: "warning",
            confirmStyle: "deep-blue",
            confirmText: "OK",
          });

          return;
        }
      }

      setLetterData((prev) => {
        let updatedJointers = [...prev.jointers];

        if (isCableAccessory) {
          // Only one jointer allowed
          updatedJointers = [updatedJointers[0]];
        } else if (isProject) {
          const filledCount = updatedJointers.filter(
            (j) => j?.name?.value,
          ).length;
          const editingExists = updatedJointers.some((j) => j.isEditing);

          if (filledCount < 3 && !editingExists) {
            updatedJointers.push({
              name: { value: "", error: "" },
              validId: { value: "", error: "" },
              photo: { value: null, preview: "", error: "" },
              isEditing: true,
              isSupport: { value: "NO", error: "" },
            });
          }
        }

        return {
          ...prev,
          productCategory: {
            ...prev.productCategory,
            value,
            error: "",
          },
          jointers: updatedJointers,
        };
      });

      return;
    }

    if (field === "letterScopeType") {
      let updatedJointers = [...letterData.jointers];

      const isCableAccessory = isCableAccessorySelected();

      if (value !== "INDIVIDUAL" && !isCableAccessory) {
        //if user swutch from individual to group show one empty row
        if (updatedJointers.length === 1) {
          updatedJointers.push({
            name: { value: "", error: "" },
            validId: { value: "", error: "" },
            photo: { value: null, preview: "", error: "" },
            isEditing: true,
            isSupport: { value: "NO", error: "" },
          });
        }
      }
      // || value === "PROJECT_FREE" condition added on 14 Apr as per new change request
      if (value === "INDIVIDUAL" || value === "PROJECT_FREE") {
        // If user switch from group - individual show only one row
        updatedJointers = [updatedJointers[0]];
      }

      setLetterData((prev) => ({
        ...prev,
        letterScopeType: {
          ...prev.letterScopeType,
          value,
          error: "",
        },
        jointers: updatedJointers,
      }));

      return;
    }

    if (field === "letterType") {
      setLetterData((prev) => {
        const cleared = { ...prev };

        Object.keys(cleared).forEach((key) => {
          if (Array.isArray(cleared[key])) {
            if (key === "jointers") {
              cleared[key] = cleared[key].map((j) => ({
                ...j,
                name: { ...j.name, error: "" },
                validId: { ...j.validId, error: "" },
                photo: { ...j.photo, error: "" },
                isSupport: { ...j.isSupport, error: "" },
              }));
            }

            if (key === "tools") {
              cleared[key] = cleared[key].map((t) => ({
                ...t,
                description: { ...t.description, error: "" },
                qty: { ...t.qty, error: "" },
              }));
            }

            return;
          }

          if (cleared[key]?.error !== undefined) {
            cleared[key].error = "";
          }
        });

        return {
          ...cleared,
          letterType: {
            ...cleared.letterType,
            value,
            error: "",
          },
        };
      });

      return;
    }

    if (field === "natureOfWork") {
      setLetterData((prev) => ({
        ...prev,
        natureOfWork: {
          ...prev[field],
          value,
          error: "",
        },
      }));

      // if nature of work is Supervision then set isSupport of jointers to NO
      if (value.includes(6)) {
        const updatedJointers = letterData?.jointers?.map((jointer) => ({
          ...jointer,
          isSupport: {
            ...jointer.isSupport,
            value: "NO",
          },
        }));

        setLetterData((prev) => ({
          ...prev,
          jointers: updatedJointers,
        }));

        return;
      }
    }

    setLetterData((prev) => ({
      ...prev,
      [field]: {
        ...prev[field],
        value,
        error: "",
      },
    }));
  };

  useEffect(() => {
    const filters = JSON.stringify([
      {
        field: "ContentType",
        condition: "in",
        filterValues: LETTER_FILTER_VALUES,
      },
    ]);

    getLetterTemplateContent(dispatch, filters);
  }, [dispatch]);

  const getOptionsByType = (type) => {
    const list = templateContent?.data?.LetterTemplateContent || [];

    return list
      .filter((item) => item.contentType === type)
      .map((item) => ({
        value: item.ID,
        label: item.contentValue,
        ID: item.ID,
        ContentType: item.contentType,
        ContentValue: item.contentValue,
      }));
  };

  const handleJointerFieldChange = (index, field, value) => {
    const updated = [...letterData.jointers];
    if (field === "photo") {
      const file = value;

      if (
        !file &&
        updated[index].letterUserId &&
        updated[index].photo.preview
      ) {
        setDeleteTracker((prev) => ({
          ...prev,
          photos: [...prev.photos, updated[index].letterUserId],
        }));
      }

      updated[index].photo = {
        value: file,
        preview: file ? URL.createObjectURL(file) : "",
        name: file ? file.name : "",
        error: "",
      };
    } else if (field === "validId") {
      updated[index].validId = {
        ...updated[index].validId,
        value,
        error: "",
      };
    } else if (field === "isSupport") {
      updated[index].isSupport = {
        ...updated[index].isSupport,
        value,
        error: "",
      };
    } else {
      updated[index][field] = {
        ...updated[index][field],
        value,
        error: "",
      };

      if (field === "name") {
        const image = value?.user?.profileImagePath || "";
        updated[index].photo = {
          ...updated[index].photo,
          value: null,
          preview: image,
          error: "",
        };
        const governmentID = value?.user?.governmentID || "";
        updated[index].validId = {
          ...updated[index].validId,
          value: governmentID,
          error: "",
        };
      }
    }

    setLetterData({ ...letterData, jointers: updated });
  };

  const handleToolChange = (index, field, value) => {
    const updated = [...letterData.tools];
    updated[index][field] = {
      ...updated[index][field],
      value,
      error: "",
    };
    setLetterData({ ...letterData, tools: updated });
  };

  const getValidationError = (name, value) => {
    const trimmedValue = typeof value === "string" ? value.trim() : value;
    const isTool = letterData.letterType.value === "TOOL_LETTER";

    switch (name) {
      case "project":
        if (
          (letterData.letterScopeType.value !== "INDIVIDUAL" ||
            letterData.letterType.value === "TOOL_LETTER") &&
          !trimmedValue
        ) {
          return "Please enter project name";
        }
        return "";

      case "issuedToCustomer":
        if (
          letterData.letterScopeType.value !== "INDIVIDUAL" &&
          letterData.letterType.value === "AUTHORIZATION_LETTER" &&
          !trimmedValue
        ) {
          return "Please enter customer name";
        }
        return "";

      case "issueDate": {
        if (!trimmedValue) {
          return "Please select issued date";
        }

        return "";
      }

      case "validTill":
        return !trimmedValue ? "Please select valid till date" : "";

      case "fromLocation":
        if (letterData.toLocation.value && !trimmedValue) {
          return "Please enter From Location";
        }
        return "";

      case "toLocation":
        if (letterData.fromLocation.value && !trimmedValue) {
          return "Please enter To Location";
        }
        return "";

      case "agency":
        if (letterData.letterType.value !== "TOOL_LETTER" && !trimmedValue) {
          return "Please enter request of (Self / Channel Partner / EPC Contractor )";
        }
        return "";

      case "productCategory":
        if (isTool) return "";
        return !value || value.length === 0
          ? "Please select product category"
          : "";

      case "voltageClass":
        return !value || value.length === 0
          ? "Please select voltage class"
          : "";

      case "natureOfWork":
        if (isTool) return "";
        if (!value || value.length === 0) {
          return "Please select nature of work";
        }
        return "";

      default:
        return "";
    }
  };

  const validateJointers = () => {
    const updated = letterData.jointers.map((j) => ({
      ...j,
      name: { ...j.name, error: "" },
      validId: { ...j.validId, error: "" },
      photo: { ...j.photo, error: "" },
      isSupport: { ...j.isSupport, error: "" },
    }));

    const selectedCount = updated.filter((j) => j?.name?.value).length;

    if (selectedCount === 0 && updated.length > 0) {
      updated[0].name.error = "Please select a jointer.";
    }
    if (letterData.letterType.value !== "TOOL_LETTER") {
      if (updated[0].name.value && (!updated[0].validId.value && !updated[0].photo.preview)) {
        updated[0].validId.error =
          "Government ID is missing for the selected jointer. Please update their profile.";
        updated[0].photo.error =
          "Profile photo is missing for the selected jointer. Please update their profile.";

        showAlert({
          title: `Incomplete Jointer Profile`,
          message: `Government ID and Profile photo are missing for the selected jointer. Please update their profile to continue.`,
          type: "warning",
          showCancel: false,
          confirmText: "OK",
          confirmStyle: "deep-blue",
          allowOutsideClick: false
        });

      } else if (updated[0].name.value && !updated[0].validId.value) {
        updated[0].validId.error =
          "Government ID is missing for the selected jointer. Please update their profile.";

        showAlert({
          title: `Incomplete Jointer Profile`,
          message: `Government ID is missing for the selected jointer. Please update their profile to continue.`,
          type: "warning",
          showCancel: false,
          confirmText: "OK",
          confirmStyle: "deep-blue",
          allowOutsideClick: false
        });
      } else if (updated[0].name.value && !updated[0].photo.preview) {
        updated[0].photo.error =
          "Profile photo is missing for the selected jointer. Please update their profile.";

        showAlert({
          title: `Incomplete Jointer Profile`,
          message: `Profile photo is missing for the selected jointer. Please update their profile to continue.`,
          type: "warning",
          showCancel: false,
          confirmText: "OK",
          confirmStyle: "deep-blue",
          allowOutsideClick: false
        });
      }
    }

    // || letterData.letterScopeType.value === "PROJECT_FREE" condition added on 14 Apr as per new change request
    if (
      letterData.letterType.value !== "TOOL_LETTER" &&
      (letterData.letterScopeType.value === "INDIVIDUAL" ||
        letterData.letterScopeType.value === "PROJECT_FREE")
    ) {
      if (selectedCount > 1) {
        updated.forEach((j) => {
          if (j?.name?.value) {
            j.name.error = "Only one jointer allowed for Individual.";
          }
        });
      }
    }

    setLetterData((prev) => ({
      ...prev,
      jointers: updated,
    }));

    return updated.every(
      (j) =>
        j.name.error === "" && j.validId.error === "" && j.photo.error === "",
    );
  };

  const handleJointerBlur = (index) => {
    const updated = [...letterData.jointers];
    const current = updated[index];

    if (!current.name.value) {
      current.name.error = "Please select a jointer.";
    } else {
      current.name.error = "";
    }

    // if (current.name.value && (!current.validId.value && !current.photo.preview)) {
    //   current.validId.error =
    //     "Government ID is missing for the selected jointer. Please update their profile.";
    //   current.photo.error =
    //     "Profile photo is missing for the selected jointer. Please update their profile.";

    //   showAlert({
    //     title: `Incomplete Jointer Profile`,
    //     message: `Government ID and Profile photo are missing for the selected jointer. Please update their profile to continue.`,
    //     type: "warning",
    //     showCancel: false,
    //     confirmText: "OK",
    //     confirmStyle: "deep-blue",
    //     allowOutsideClick: false
    //   });

    // } else if (current.name.value && !current.validId.value) {
    //   current.validId.error =
    //     "Government ID is missing for the selected jointer. Please update their profile.";

    //   showAlert({
    //     title: `Incomplete Jointer Profile`,
    //     message: `Government ID is missing for the selected jointer. Please update their profile to continue.`,
    //     type: "warning",
    //     showCancel: false,
    //     confirmText: "OK",
    //     confirmStyle: "deep-blue",
    //     allowOutsideClick: false
    //   });
    // } else if (current.name.value && !current.photo.preview) {
    //   current.photo.error =
    //     "Profile photo is missing for the selected jointer. Please update their profile.";

    //   showAlert({
    //     title: `Incomplete Jointer Profile`,
    //     message: `Profile photo is missing for the selected jointer. Please update their profile to continue.`,
    //     type: "warning",
    //     showCancel: false,
    //     confirmText: "OK",
    //     confirmStyle: "deep-blue",
    //     allowOutsideClick: false
    //   });
    // }

    setLetterData((prev) => ({
      ...prev,
      jointers: updated,
    }));
  };

  const handleToolBlur = (index, field) => {
    const updated = [...letterData.tools];
    const current = updated[index];

    if (field === "description") {
      if (!current.description.value.trim()) {
        current.description.error = "Please enter item description";
      } else {
        current.description.error = "";
      }
    }

    if (field === "qty") {
      const qty = current.qty.value.trim();

      if (!qty) {
        current.qty.error = "Please enter quantity";
      } else if (!REGEX.TOOLS_QTY_REGEX.test(qty)) {
        current.qty.error =
          "Please enter quantity along with unit (Nos, Set, Box each, Nos each, Set each, Item, Items).";
      } else {
        current.qty.error = "";
      }
    }

    setLetterData((prev) => ({
      ...prev,
      tools: updated,
    }));
  };

  const validateTools = () => {
    if (letterData.letterType.value !== "TOOL_LETTER") return true;

    const updated = letterData.tools.map((t) => ({
      ...t,
      description: { ...t.description, error: "" },
      qty: { ...t.qty, error: "" },
    }));

    let hasError = false;

    updated.forEach((tool) => {
      const desc = tool.description.value.trim();
      const qty = tool.qty.value.trim();

      if (!desc) {
        tool.description.error = "Please enter item description";
        hasError = true;
      }

      if (!qty) {
        tool.qty.error = "Please enter quantity";
        hasError = true;
      } else if (!REGEX.TOOLS_QTY_REGEX.test(qty)) {
        tool.qty.error =
          "Please enter quantity along with unit (Nos, Set, Box each, Nos each, Set each, Item, Items).";
        hasError = true;
      }
    });

    const validTools = updated.filter(
      (t) =>
        t.description.value.trim() &&
        REGEX.TOOLS_QTY_REGEX.test(t.qty.value.trim()),
    );

    if (mode === "edit" && validTools.length === 0) {
      // notify("danger", "Please add at least one tool before preview.");
      hasError = true;
    }

    setLetterData((prev) => ({
      ...prev,
      tools: updated,
    }));

    return !hasError;
  };

  //on blur to get if any validation error exits
  const handleOnBlur = (name, value) => {
    const trimmedValue = typeof value === "string" ? value.trim() : value;
    const error = getValidationError(name, trimmedValue);
    setLetterData((prev) => ({
      ...prev,
      [name]: {
        ...prev[name],
        value: trimmedValue,
        error,
      },
    }));
  };

  const handleSaveJointer = (index) => {
    const updated = [...letterData.jointers];
    const currentRow = updated[index];
    let hasError = false;

    if (!currentRow.name.value) {
      currentRow.name.error = "Please select a jointer.";
      hasError = true;
    } else {
      currentRow.name.error = "";
    }

    if (letterData.letterType.value !== "TOOL_LETTER") {
      if (currentRow.name.value && (!currentRow.validId.value && !currentRow.photo.preview)) {
        currentRow.validId.error =
          "Government ID is missing for the selected jointer. Please update their profile.";
        currentRow.photo.error =
          "Profile photo is missing for the selected jointer. Please update their profile.";
        hasError = true;

        showAlert({
          title: `Incomplete Jointer Profile`,
          message: `Government ID and Profile photo are missing for the selected jointer. Please update their profile to continue.`,
          type: "warning",
          showCancel: false,
          confirmText: "OK",
          confirmStyle: "deep-blue",
          allowOutsideClick: false
        });

      } else if (currentRow.name.value && !currentRow.validId.value) {
        currentRow.validId.error =
          "Government ID is missing for the selected jointer. Please update their profile.";
        hasError = true;

        showAlert({
          title: `Incomplete Jointer Profile`,
          message: `Government ID is missing for the selected jointer. Please update their profile to continue.`,
          type: "warning",
          showCancel: false,
          confirmText: "OK",
          confirmStyle: "deep-blue",
          allowOutsideClick: false
        });
      } else if (currentRow.name.value && !currentRow.photo.preview) {
        currentRow.photo.error =
          "Profile photo is missing for the selected jointer. Please update their profile.";
        hasError = true;

        showAlert({
          title: `Incomplete Jointer Profile`,
          message: `Profile photo is missing for the selected jointer. Please update their profile to continue.`,
          type: "warning",
          showCancel: false,
          confirmText: "OK",
          confirmStyle: "deep-blue",
          allowOutsideClick: false
        });
      }
    }
    // currentRow.validId.error = "";

    // Photo Validation
    if (currentRow.photo.value) {
      const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];
      if (!allowedTypes.includes(currentRow.photo.value?.type)) {
        currentRow.photo.error = "Only JPG, JPEG and PNG images are allowed";
        hasError = true;
      } else {
        currentRow.photo.error = "";
      }
    } else {
      // currentRow.photo.error = ""; // no photo is okay
    }

    if (hasError) {
      setLetterData((prev) => ({
        ...prev,
        jointers: updated,
      }));
      return;
    }

    currentRow.isEditing = false;

    const scope = letterData.letterScopeType.value;

    // || scope === "PROJECT_FREE" condition removed on 14 Apr as per new change request
    const isProject =
      scope === "PROJECT_PAID" || letterData.letterType.value === "TOOL_LETTER"; // || scope === "PROJECT_FREE";

    const isCableAccessory = isCableAccessorySelected();

    if (isProject && !isCableAccessory && index === updated.length - 1) {
      const filledCount = updated.filter((j) => j?.name?.value).length;

      if (filledCount >= 3) {
        // notify("warning", "Maximum 3 jointers allowed.");
      } else {
        updated.push({
          name: { value: "", error: "" },
          validId: { value: "", error: "" },
          photo: { value: null, preview: "", error: "" },
          isEditing: true,
          isSupport: { value: "NO", error: "" },
        });
      }
    }

    setLetterData((prev) => ({
      ...prev,
      jointers: updated,
    }));
  };

  const handleEditJointer = (index) => {
    const updated = [...letterData.jointers];

    updated[index].isEditing = true;
    setLetterData({ ...letterData, jointers: updated });
  };

  //function to remove jointer from table in both the case individual- reset exisiting row and group - delete normally
  const handleDeleteJointer = async (letterUserID) => {
    try {
      // setShowLoaderOnClick(true);
      const res = await deleteLetterUser(letterUserID);
      if (res?.code === 200) {
        const message = Array.isArray(res?.message)
          ? res?.message[0]?.Msg
          : res?.message || "Jointer deleted successfully";

        notify("success", message);
        fetchLetterDetails(decodedId || letterID);
      } else {
        const message = Array.isArray(res?.message)
          ? res?.message[0]?.Msg
          : res?.message || "Failed to delete jointer";
        notify("danger", message);
      }
    } catch (error) {
      notify("danger", "Delete failed!");
    } finally {
      // setShowLoaderOnClick(false);
    }
  };

  const handleRemoveJointer = (index, jointer) => {
    if (jointer?.letterUserId) {
      showAlert({
        title: "Delete Jointer",
        message: "Are you sure you want to delete this jointer?",
        type: "warning",
        confirmStyle: "deep-blue",
        cancelStyle: "secondary",
        confirmText: "Delete",
        cancelText: "Cancel",
        onConfirm: () => handleDeleteJointer(jointer.letterUserId),
      });
    } else {
      const updated = letterData.jointers.filter((_, i) => i !== index);

      const scope = letterData.letterScopeType.value;
      // || scope === "PROJECT_FREE" condition removed on 14 Apr as per new change request
      const isProject = scope === "PROJECT_PAID"; // || scope === "PROJECT_FREE";

      let finalJointers = [...updated];

      // ensure editing row exists for project scope
      const isCableAccessory = isCableAccessorySelected();

      if (isProject && !isCableAccessory) {
        const editingExists = finalJointers.some((j) => j.isEditing);

        if (!editingExists && finalJointers.length < 3) {
          finalJointers.push({
            name: { value: "", error: "" },
            validId: { value: "", error: "" },
            photo: { value: null, preview: "", error: "" },
            isEditing: true,
            isSupport: { value: "NO", error: "" },
          });
        }
      }

      // fallback if everything deleted
      if (finalJointers.length === 0) {
        finalJointers = [
          {
            name: { value: "", error: "" },
            validId: { value: "", error: "" },
            photo: { value: null, preview: "", error: "" },
            isEditing: true,
            isSupport: { value: "NO", error: "" },
          },
        ];
      }

      setLetterData((prev) => ({
        ...prev,
        jointers: finalJointers,
      }));
    }
  };

  //on add click save existing enter data and display as label and show new empty row
  const handleSaveTool = (index) => {
    const updated = [...letterData.tools];
    const currentRow = updated[index];
    let hasError = false;

    // Description validation
    if (!currentRow.description.value.trim()) {
      currentRow.description.error = "Please enter item description";
      hasError = true;
    } else {
      currentRow.description.error = "";
    }

    // Quantity validation
    if (!currentRow.qty.value.trim()) {
      currentRow.qty.error = "Please enter quantity";
      hasError = true;
    } else if (!REGEX.TOOLS_QTY_REGEX.test(currentRow.qty.value.trim())) {
      currentRow.qty.error =
        "Please enter quantity along with unit (Nos, Set, Box each, Nos each, Set each, Item, Items).";

      hasError = true;
    } else {
      currentRow.qty.error = "";
    }

    if (hasError) {
      setLetterData((prev) => ({
        ...prev,
        tools: updated,
      }));
      return;
    }

    currentRow.isEditing = false;
    if (index === updated.length - 1) {
      updated.push({
        description: { value: "", error: "" },
        qty: { value: "", error: "" },
        isEditing: true,
      });
    }

    setLetterData((prev) => ({
      ...prev,
      tools: updated,
    }));
  };

  const handleEditTool = (index) => {
    const updated = [...letterData.tools];
    updated[index].isEditing = true; // Enable editing on that row
    setLetterData({ ...letterData, tools: updated });
  };

  const handleRemoveTool = async (index) => {
    showAlert({
      title: "Delete Tool",
      message: "Are you sure you want to delete this tool?",
      type: "warning",
      confirmStyle: "deep-blue",
      cancelStyle: "secondary",
      confirmText: "Delete",
      cancelText: "Cancel",
      onConfirm: () => handleDeleteToolItem(index),
    });
  };

  const handleDeleteToolItem = async (index) => {
    const updated = [...letterData.tools];
    updated[index].isDeleted = true;

    setLetterData({ ...letterData, tools: updated });

    try {
      const changedFields = toolItemsDeletedFields();

      const res = await deleteToolItems(decodedId || letterID, { tools: changedFields });
      if (res?.code === 200) {
        notify("success", res?.message || "Tool deleted successfully");

        await fetchLetterDetails(decodedId || letterID);
      } else {
        const message = Array.isArray(res?.message)
          ? res?.message[0]?.Msg
          : res?.message || "Failed to update tools";
        notify("danger", message);
      }
    } catch (err) {
      notify("danger", err?.message || "Error while deleting tool");
    }
  }

  const handleOnCancel = () => {
    setLetterData(getInitialFields());
    setLetterID(null);
    navigate(
      role === "SUPER_ADMIN" ? "/super-admin/letters" : "/admin/letters",
    );
  };

  const validateForm = () => {
    let newData = { ...letterData };
    Object.keys(newData).forEach((key) => {
      // Skip arrays like  (jointers, tools)
      if (Array.isArray(newData[key])) return;
      newData[key] = {
        ...newData[key],
        error: getValidationError(key, newData[key].value),
      };
    });

    setLetterData(newData);
    // Only check non-array fields
    return Object.keys(newData)
      .filter((key) => !Array.isArray(newData[key]))
      .every((key) => newData[key].error === "");
  };

  const mapToFullObjects = (type, selectedIds) => {
    const options = getOptionsByType(type);
    return options
      .filter((opt) => selectedIds.includes(opt.value))
      .map((opt) => ({
        id: opt.ID,
        contentType: opt.ContentType,
        contentValue: opt.ContentValue,
      }));
  };

  const toolChangedFields = () => {
    const changed = {};

    // simple fields
    ["project", "issuedToCustomer", "issueDate", "validTill"].forEach((key) => {
      if (letterData[key].value !== letterData[key].oldValue) {
        changed[key] = letterData[key].value;
      }
    });

    const voltageChanged =
      JSON.stringify(letterData.voltageClass.value) !==
      JSON.stringify(letterData.voltageClass.oldValue);

    if (voltageChanged) {
      changed.voltageClass = mapToFullObjects(
        "VOLTAGE_CLASS",
        letterData.voltageClass.value,
      );
    }

    // from/to location
    if (letterData.fromLocation.value !== letterData.fromLocation.oldValue) {
      changed.fromLocation = letterData.fromLocation.value;
    }

    if (letterData.toLocation.value !== letterData.toLocation.oldValue) {
      changed.toLocation = letterData.toLocation.value;
    }

    // jointers
    const jointerChanged = letterData.jointers.some((j) => {
      return j?.name?.value?.userID !== j?.name?.oldValue?.userID;
    });

    if (jointerChanged) {
      changed.jointers = letterData.jointers
        .filter((j) => j?.name?.value)
        .map((j) => ({
          id: j?.name?.value?.userID,
          name: j?.name?.value?.user?.fullName,
        }));
    }

    const currentTools = letterData.tools
      .filter((t) => !t.isDeleted)
      .filter((t) => t.description.value.trim() && t.qty.value.trim())
      .map((t) => ({
        description: t.description.value,
        qty: t.qty.value,
      }));

    const oldTools = letterData.tools
      .filter((t) => t.description.oldValue || t.qty.oldValue)
      .map((t) => ({
        description: t.description.oldValue || "",
        qty: t.qty.oldValue || "",
      }));

    const toolsChanged =
      currentTools.length !== oldTools.length ||
      JSON.stringify(currentTools) !== JSON.stringify(oldTools);

    if (toolsChanged) {
      changed.toolsList = letterData.tools
        .filter((t) => !t.isDeleted)
        .filter((t) => t.description.value.trim() && t.qty.value.trim())
        .map((t, index) => ({
          id: index + 1,
          itemDescription: t.description.value,
          quantity: t.qty.value,
        }));
    }

    return changed;
  };

  const toolItemsDeletedFields = () => {
    var changed = [];

    const hasDeleted = letterData.tools.some((t) => t.isDeleted);

    if (hasDeleted) {
      changed = letterData.tools
        .filter((t) => !t.isDeleted)
        .filter((t) => t.description.value.trim() && t.qty.value.trim())
        .map((t, index) => ({
          id: index + 1,
          itemDescription: t.description.value,
          quantity: t.qty.value,
        }));
    }

    return changed;
  };

  const handleOnPreview = async () => {
    const isFormValid = validateForm();
    const isJointerValid = validateJointers();

    let isToolsValid = true;

    if (letterData.letterType.value === "TOOL_LETTER") {
      const hasValidTool = letterData.tools.some(
        (t) =>
          !t.isDeleted &&
          t.description.value.trim() &&
          REGEX.TOOLS_QTY_REGEX.test(t.qty.value.trim()),
      );

      if (!hasValidTool) {
        isToolsValid = validateTools();
      }
    }

    if (!isFormValid || !isJointerValid || !isToolsValid) {
      return;
    }

    setShowLoaderOnClick(true);
    try {
      const mapToFullObjects = (type, selectedIds) => {
        const options = getOptionsByType(type);
        return options
          .filter((opt) => selectedIds.includes(opt.value))
          .map((opt) => ({
            id: opt.ID,
            contentType: opt.ContentType,
            contentValue: opt.ContentValue,
          }));
      };
      const isToolLetter = letterData.letterType.value === "TOOL_LETTER";

      let letterPayload;

      if (isToolLetter) {
        letterPayload = {
          letterType: "TOOL_LETTER",

          project: letterData.project.value,
          issuedToCustomer: letterData.issuedToCustomer.value,

          issueDate: letterData.issueDate.value,
          validTill: letterData.validTill.value,
          ...(letterData.fromLocation.value && {
            fromLocation: letterData.fromLocation.value,
          }),

          ...(letterData.toLocation.value && {
            toLocation: letterData.toLocation.value,
          }),

          jointers: letterData.jointers
            .filter((j) => j?.name?.value)
            .map((j) => ({
              id: j?.name?.value?.userID,
              name: j?.name?.value?.user?.fullName,
            })),

          voltageClass: mapToFullObjects(
            "VOLTAGE_CLASS",
            letterData.voltageClass.value,
          ),

          toolsList: letterData.tools
            .filter((t) => !t.isDeleted)
            .filter((t) => t.description.value.trim() && t.qty.value.trim())
            .map((t, index) => ({
              id: index + 1,
              itemDescription: t.description.value,
              quantity: t.qty.value,
            })),
        };
      } else {
        // EXISTING LOGIC (KEEP SAME)
        const isIndividual = letterData.letterScopeType.value === "INDIVIDUAL";

        letterPayload = {
          letterType: letterData.letterType.value,
          letterScope: letterData.letterScopeType.value,
          issueDate: letterData.issueDate.value,
          validTill: letterData.validTill.value,

          ...(!isIndividual && {
            project: letterData.project.value,
            issuedToCustomer: letterData.issuedToCustomer.value,
          }),

          agency: letterData.agency.value,

          productCategory: mapToFullObjects(
            "PRODUCT_CATEGORY",
            letterData.productCategory.value,
          ),

          natureOfWork: mapToFullObjects(
            "NATURE_OF_WORK",
            letterData.natureOfWork.value,
          ),

          voltageClass: mapToFullObjects(
            "VOLTAGE_CLASS",
            letterData.voltageClass.value,
          ),

          termination: mapToFullObjects(
            "TERMINATION",
            letterData.termination.value,
          ),

          plugInTermination: mapToFullObjects(
            "PLUG_IN_TERMINATION",
            letterData.pluginTermination.value,
          ),

          joints: mapToFullObjects("JOINTS", letterData.joints.value),

          jointers: letterData.jointers
            .filter((j) => j?.name?.value)
            .map((j) => ({
              id: j?.name?.value?.userID,
              name: j?.name?.value?.user?.fullName,
              governmentID: j.validId.value,
              isSupport: j.isSupport.value,
            })),
        };
      }
      let formData = new FormData();

      formData.append("letterform", JSON.stringify(letterPayload));

      if (!isToolLetter) {
        if (letterID) {
          formData.append("referenceNo", letterID);
        }

        letterData.jointers.forEach((j) => {
          if (!j?.name?.value?.userID) return;

          const key = `jointer_${j?.name?.value.userID}`;

          if (j.photo.value instanceof File) {
            formData.append(key, j.photo.value);
          } else if (j.photo.preview) {
            formData.append(key, j.photo.preview);
          }
        });
      }

      let res;

      if (isToolLetter) {
        if (letterID) {
          const changedFields = toolChangedFields();

          const editFormData = new FormData();
          editFormData.append("letterform", JSON.stringify(changedFields));

          res = await updateLetter(decodedId || letterID, editFormData);
        } else {
          res = await createLetter(formData);
        }
      } else {
        if (letterID) {
          const changedFields = getChangedFields();

          if (deleteTracker.users.length > 0) {
            changedFields.delete_user = deleteTracker.users;
          }

          if (deleteTracker.photos.length > 0) {
            changedFields.delete_photo = deleteTracker.photos;
          }

          const mapToFullObjects = (type, selectedIds) => {
            const options = getOptionsByType(type);
            return options
              .filter((opt) => selectedIds.includes(opt.value))
              .map((opt) => ({
                id: opt.ID,
                contentType: opt.ContentType,
                contentValue: opt.ContentValue,
              }));
          };

          // Convert only if changed
          if (changedFields.productCategory) {
            changedFields.productCategory = mapToFullObjects(
              "PRODUCT_CATEGORY",
              changedFields.productCategory,
            );
          }

          if (changedFields.natureOfWork) {
            changedFields.natureOfWork = mapToFullObjects(
              "NATURE_OF_WORK",
              changedFields.natureOfWork,
            );
          }

          if (changedFields.voltageClass) {
            changedFields.voltageClass = mapToFullObjects(
              "VOLTAGE_CLASS",
              changedFields.voltageClass,
            );
          }

          if (changedFields.termination) {
            changedFields.termination = mapToFullObjects(
              "TERMINATION",
              changedFields.termination,
            );
          }

          if (changedFields.pluginTermination) {
            changedFields.plugInTermination = mapToFullObjects(
              "PLUG_IN_TERMINATION",
              changedFields.pluginTermination,
            );

            delete changedFields.pluginTermination; // important
          }

          if (changedFields.joints) {
            changedFields.joints = mapToFullObjects(
              "JOINTS",
              changedFields.joints,
            );
          }

          // if (Object.keys(changedFields).length === 0) {
          //   notify("warning", "No changes detected");
          //   setShowLoaderOnClick(false);
          //   return;
          // }

          const editFormData = new FormData();
          editFormData.append("letterform", JSON.stringify(changedFields));

          // if (letterID) {
          //   editFormData.append("referenceNo", letterID);
          // }

          // Append photos if changed
          letterData.jointers.forEach((j) => {
            if (!j?.name?.value?.userID) return;

            const key = `jointer_${j?.name?.value.userID}`;

            if (j.photo.value instanceof File) {
              editFormData.append(key, j.photo.value);
            } else if (j.photo.preview) {
              editFormData.append(key, j.photo.preview);
            }
          });

          res = await updateLetter(decodedId || letterID, editFormData);
        } else {
          res = await createLetter(formData);
        }
      }

      const contentType = res?.headers?.["content-type"];
      const refNo = res?.headers?.["x-reference-number"];

      if (contentType?.includes("application/pdf")) {
        if (res?.status === 200) {
          const fileURL = URL.createObjectURL(res?.data);

          setPreviewModal({ isOpen: true, fileUrl: fileURL });

          if (refNo) {
            setLetterID(refNo);
          }
          setDeleteTracker({ users: [], photos: [] });
        } else {
          const message = Array.isArray(res?.message)
            ? res?.message[0]?.Msg
            : res?.message || "Failed to generate letter. Please try again.";
          notify("danger", message);
        }
      } else {
        const message = Array.isArray(res?.message)
          ? res?.message[0]?.Msg
          : res?.message || "Failed to generate letter. Please try again.";
        notify("danger", message);
      }
    } catch (error) {
      notify("danger", "Failed to generate letter!");
    } finally {
      setShowLoaderOnClick(false);
    }
  };

  const handleRequestApproval = () => {
    const letterId = decodedId || letterID;

    if (!letterId) {
      notify("danger", "Reference number not found.");
      return;
    }

    showAlert({
      title: "Are you sure you want to request approval?",
      message: "Once requested, this letter cannot be edited.",
      type: "warning",
      confirmStyle: "deep-blue",
      cancelStyle: "secondary",
      confirmText: "Yes",
      cancelText: "Cancel",
      onConfirm: async () => {
        try {
          setShowLoaderOnClick(true);

          const res = await requestLetterApproval(letterId);

          if (res?.status === 200 || res?.code === 200) {
            notify(
              "success",
              res?.message || "Approval requested successfully.",
            );
            setPreviewModal({ isOpen: false, fileUrl: "" });
            navigate(
              role === "SUPER_ADMIN"
                ? "/super-admin/letters"
                : "/admin/letters",
            );
          } else {
            const message =
              res?.message || "Failed to request approval. Please try again.";
            notify("danger", message);
          }
        } catch (error) {
          notify("danger", "Failed to request approval.");
        } finally {
          setShowLoaderOnClick(false);
        }
      },
    });
  };

  const handleClosePreviewModal = async () => {
    setPreviewModal({ isOpen: false, fileUrl: "" });

    if (letterID) {
      await fetchLetterDetails(letterID);
      setMode("edit");
    }
  };

  const isCableAccessorySelected = () => {
    if (letterData.letterType.value === "TOOL_LETTER") return false;

    const options = getOptionsByType("PRODUCT_CATEGORY");

    const cableAccessory = options.find(
      (opt) => opt.label === "Cable Accessories",
    );

    return cableAccessory
      ? letterData.productCategory.value.includes(cableAccessory.value)
      : false;
  };

  return (
    <>
      <AdminHeader />
      <Container fluid className="mt--6">
        <Card>
          <CardHeader>
            <div className="d-flex align-items-center">
              <i
                className="fa fa-chevron-left mr-2 cursor"
                onClick={() =>
                  navigate(
                    role === "SUPER_ADMIN"
                      ? "/super-admin/letters"
                      : "/admin/letters",
                  )
                }
              />
              <h3 className="mb-0">
                {mode === "edit" ? "Edit Letter" : "Generate Letter"}
              </h3>
            </div>

            {letterData.status.value === "REJECTED" && (
              <div className="mt-2">
                <span>Status:</span>{" "}
                <span className="badge badge-danger ml-2">Rejected</span>
                <div className="mt-1">
                  <span>Rejection Reason:</span>{" "}
                  <strong>{letterData.rejectionReason.value || "-"}</strong>
                </div>
              </div>
            )}
          </CardHeader>

          <CardBody>
            <Form>
              <Row>
                <Col md="4">
                  <FormGroup>
                    <Label className="form-control-label">
                      Letter Type <span className="text-danger">*</span>
                      <InfoPopover
                        targetId="letterType"
                        title="Letter Type"
                        content="Select the type of letter to be issued — Authorization Letter or Tool Letter."
                      />
                    </Label>

                    <div className="d-flex mt-2">
                      <FormGroup check className="mr-4">
                        <Label check>
                          <Input
                            type="radio"
                            value="AUTHORIZATION_LETTER"
                            checked={
                              letterData.letterType.value ===
                              "AUTHORIZATION_LETTER"
                            }
                            onChange={(e) =>
                              handleChange("letterType", e.target.value)
                            }
                            // disabled={mode === "edit"}
                            disabled
                          />
                          Authorization Letter
                        </Label>
                      </FormGroup>

                      {/* <FormGroup check>
                        <Label check>
                          <Input
                            type="radio"
                            value="TOOL_LETTER"
                            checked={
                              letterData.letterType.value === "TOOL_LETTER"
                            }
                            onChange={(e) =>
                              handleChange("letterType", e.target.value)
                            }
                            disabled={mode === "edit"}
                          />
                          Tool Letter
                        </Label>
                      </FormGroup> */}
                    </div>
                  </FormGroup>
                </Col>

                <Col md="4">
                  <FormGroup>
                    <Label className="form-control-label">
                      Issue Date <span className="text-danger">*</span>
                    </Label>
                    <DatePicker
                      selected={letterData.issueDate.value}
                      onChange={(date) => handleChange("issueDate", date ? format(date, "yyyy-MM-dd") : "")}
                      onBlur={() => handleOnBlur("issueDate", letterData.issueDate.value)}
                      dateFormat="yyyy-MM-dd"
                      placeholderText="YYYY-MM-DD"
                      showIcon
                      showMonthDropdown
                      showYearDropdown
                      scrollableYearDropdown
                      yearDropdownItemNumber={100}
                      icon={
                        <i className="fa-solid fa-calendar-day fa-md mt-1 mr-4 text-muted" />
                      }
                      toggleCalendarOnIconClick
                      className={`form-control ${letterData.issueDate.error ? "is-invalid" : ""
                        }`}
                      wrapperClassName="w-100"
                      calendarClassName="custom-calendar"
                      popperPlacement="bottom-start"
                      onKeyDown={(e) => e.preventDefault()}
                      onPaste={(e) => e.preventDefault()}
                    />
                    {letterData.issueDate.error && (
                      <div className="invalid-feedback d-block">
                        {letterData.issueDate.error}
                      </div>
                    )}
                  </FormGroup>
                </Col>

                <Col md="4">
                  <FormGroup>
                    <Label className="form-control-label">
                      Valid Till <span className="text-danger">*</span>
                    </Label>
                    <DatePicker
                      selected={letterData.validTill.value}
                      onChange={(date) => handleChange("validTill", date ? format(date, "yyyy-MM-dd") : "")}
                      onBlur={() => handleOnBlur("validTill", letterData.validTill.value)}
                      dateFormat="yyyy-MM-dd"
                      placeholderText="YYYY-MM-DD"
                      showMonthDropdown
                      showYearDropdown
                      scrollableYearDropdown
                      yearDropdownItemNumber={100}
                      showIcon
                      icon={
                        <i className="fa-solid fa-calendar-day fa-md mt-1 mr-4 text-muted" />
                      }
                      minDate={letterData.issueDate.value || ""}
                      toggleCalendarOnIconClick
                      className={`form-control ${letterData.validTill.error ? "is-invalid" : ""
                        }`}
                      wrapperClassName="w-100"
                      calendarClassName="custom-calendar"
                      popperPlacement="bottom-start"
                      onKeyDown={(e) => e.preventDefault()}
                      onPaste={(e) => e.preventDefault()}
                    />
                    {letterData.validTill.error && (
                      <div className="invalid-feedback d-block">
                        {letterData.validTill.error}
                      </div>
                    )}
                  </FormGroup>
                </Col>

                {letterData.letterType.value !== "TOOL_LETTER" && (
                  <Col md="12">
                    <Row>
                      <Col md="4">
                        <FormGroup>
                          <Label className="form-control-label">
                            Letter Scope <span className="text-danger">*</span>
                            <InfoPopover
                              targetId="issuedTo"
                              title="Issued To"
                              content="Specify whether the letter is issued to a single individual or to a group of jointers."
                            />
                          </Label>
                          <div className="d-flex mt-2">
                            {LETTER_SCOPE_OPTIONS.map((option) => (
                              <FormGroup
                                check
                                className="mr-4 text-nowrap"
                                key={option.value}
                              >
                                <Label check>
                                  <Input
                                    type="radio"
                                    value={option.value}
                                    checked={
                                      letterData.letterScopeType.value ===
                                      option.value
                                    }
                                    onChange={(e) =>
                                      handleChange(
                                        "letterScopeType",
                                        e.target.value,
                                      )
                                    }
                                    disabled={mode === "edit"}
                                  />
                                  {option.label}
                                </Label>
                              </FormGroup>
                            ))}
                          </div>
                        </FormGroup>
                      </Col>
                    </Row>
                  </Col>
                )}

                {letterData.letterScopeType.value === "INDIVIDUAL" &&
                  letterData.letterType.value !== "TOOL_LETTER" && (
                    <>
                      <Col md="4">
                        <FormGroup>
                          <Label className="form-control-label">
                            Request of (Self / Channel Partner / EPC Contractor
                            ) <span className="text-danger">*</span>
                          </Label>
                          <Input
                            placeholder="Enter request type (Self / Channel Partner / EPC Contractor)"
                            name="agency"
                            value={letterData.agency.value}
                            onChange={(e) =>
                              handleChange("agency", e.target.value)
                            }
                            onBlur={(e) =>
                              handleOnBlur(e.target.name, e.target.value)
                            }
                            className={
                              letterData.agency.error ? "is-invalid" : ""
                            }
                          />
                          {letterData.agency.error && (
                            <div className="invalid-feedback d-block">
                              {letterData.agency.error}
                            </div>
                          )}
                        </FormGroup>
                      </Col>
                    </>
                  )}

                {((letterData.letterScopeType.value !== "INDIVIDUAL" &&
                  letterData.letterType.value !== "TOOL_LETTER") ||
                  letterData.letterType.value === "TOOL_LETTER") && (
                    <>
                      <Col md="4">
                        <FormGroup>
                          <Label className="form-control-label">
                            Project Name <span className="text-danger">*</span>
                          </Label>
                          <Input
                            name="project"
                            placeholder="Enter project name "
                            value={letterData.project.value}
                            onChange={(e) =>
                              handleChange("project", e.target.value)
                            }
                            onBlur={(e) =>
                              handleOnBlur(e.target.name, e.target.value)
                            }
                            className={
                              letterData.project.error ? "is-invalid" : ""
                            }
                            maxLength={150}
                          />
                          {letterData.project.error && (
                            <div className="invalid-feedback d-block">
                              {letterData.project.error}
                            </div>
                          )}
                        </FormGroup>
                      </Col>

                      <Col md="4">
                        <FormGroup>
                          <Label className="form-control-label">
                            Customer Name{" "}
                            {letterData.letterType.value ===
                              "AUTHORIZATION_LETTER" && (
                                <span className="text-danger">*</span>
                              )}
                          </Label>
                          <Input
                            name="issuedToCustomer"
                            placeholder="Enter the customer name"
                            value={letterData.issuedToCustomer.value}
                            onChange={(e) =>
                              handleChange("issuedToCustomer", e.target.value)
                            }
                            onBlur={(e) =>
                              handleOnBlur(e.target.name, e.target.value)
                            }
                            className={
                              letterData.issuedToCustomer.error
                                ? "is-invalid"
                                : ""
                            }
                            maxLength={150}
                          />
                          {letterData.issuedToCustomer.error && (
                            <div className="invalid-feedback d-block">
                              {letterData.issuedToCustomer.error}
                            </div>
                          )}
                        </FormGroup>
                      </Col>

                      {letterData.letterType.value !== "TOOL_LETTER" && (
                        <Col md="4">
                          <FormGroup>
                            <Label className="form-control-label">
                              Request of (Channel Partner / EPC Contractor/ End
                              Customer) <span className="text-danger">*</span>
                            </Label>
                            <Input
                              name="agency"
                              placeholder="Enter request of (Channel Partner / EPC Contractor / End Customer)"
                              value={letterData.agency.value}
                              onChange={(e) =>
                                handleChange("agency", e.target.value)
                              }
                              onBlur={(e) =>
                                handleOnBlur(e.target.name, e.target.value)
                              }
                              className={
                                letterData.agency.error ? "is-invalid" : ""
                              }
                              maxLength={100}
                            />

                            {letterData.agency.error && (
                              <div className="invalid-feedback d-block">
                                {letterData.agency.error}
                              </div>
                            )}
                          </FormGroup>
                        </Col>
                      )}
                    </>
                  )}
                {letterData.letterType.value !== "TOOL_LETTER" && (
                  <>
                    <Col md="4">
                      <FormGroup>
                        <Label className="form-control-label">
                          Product Category{" "}
                          <span className="text-danger">*</span>
                        </Label>

                        <Select
                          placeholder="Select product category"
                          isMulti
                          options={getOptionsByType("PRODUCT_CATEGORY")}
                          value={getOptionsByType("PRODUCT_CATEGORY").filter(
                            (opt) =>
                              letterData.productCategory.value.includes(
                                opt.value,
                              ),
                          )}
                          onChange={(selected) =>
                            handleChange(
                              "productCategory",
                              selected ? selected.map((s) => s.value) : [],
                            )
                          }
                          onBlur={() =>
                            handleOnBlur(
                              "productCategory",
                              letterData.productCategory.value,
                            )
                          }
                          styles={SELECT_CUSTOM_STYLES}
                          className={
                            letterData.productCategory.error ? "is-invalid" : ""
                          }
                        />

                        {letterData.productCategory.error && (
                          <div className="invalid-feedback d-block">
                            {letterData.productCategory.error}
                          </div>
                        )}
                      </FormGroup>
                    </Col>
                    <Col md="4">
                      <FormGroup>
                        <Label className="form-control-label">
                          Nature of Work <span className="text-danger">*</span>
                        </Label>

                        <Select
                          isMulti
                          placeholder="Select nature of work"
                          options={getOptionsByType("NATURE_OF_WORK")}
                          value={getOptionsByType("NATURE_OF_WORK").filter(
                            (opt) =>
                              letterData.natureOfWork.value.includes(opt.value),
                          )}
                          onChange={(selected) =>
                            handleChange(
                              "natureOfWork",
                              selected ? selected.map((s) => s.value) : [],
                            )
                          }
                          onBlur={() =>
                            handleOnBlur(
                              "natureOfWork",
                              letterData.natureOfWork.value,
                            )
                          }
                          styles={SELECT_CUSTOM_STYLES}
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          className={
                            letterData.natureOfWork.error ? "is-invalid" : ""
                          }
                        />

                        {letterData.natureOfWork.error && (
                          <div className="invalid-feedback d-block">
                            {letterData.natureOfWork.error}
                          </div>
                        )}
                      </FormGroup>
                    </Col>
                  </>
                )}

                <Col md="4">
                  <FormGroup>
                    <Label className="form-control-label">
                      Voltage Class <span className="text-danger">*</span>
                    </Label>

                    <Select
                      placeholder="Select voltage class"
                      isMulti
                      options={getOptionsByType("VOLTAGE_CLASS")}
                      value={getOptionsByType("VOLTAGE_CLASS").filter((opt) =>
                        letterData.voltageClass.value.includes(opt.value),
                      )}
                      onChange={(selected) =>
                        handleChange(
                          "voltageClass",
                          selected ? selected.map((s) => s.value) : [],
                        )
                      }
                      onBlur={() =>
                        handleOnBlur(
                          "voltageClass",
                          letterData.voltageClass.value,
                        )
                      }
                      styles={SELECT_CUSTOM_STYLES}
                      className={
                        letterData.voltageClass.error ? "is-invalid" : ""
                      }
                    />

                    {letterData.voltageClass.error && (
                      <div className="invalid-feedback d-block">
                        {letterData.voltageClass.error}
                      </div>
                    )}
                  </FormGroup>
                </Col>

                {isCableAccessorySelected() && (
                  <>
                    <Col md="4">
                      <FormGroup>
                        <Label className="form-control-label">
                          Termination
                        </Label>

                        <Select
                          isMulti
                          placeholder="Select termination"
                          options={getOptionsByType("TERMINATION")}
                          value={getOptionsByType("TERMINATION").filter((opt) =>
                            letterData.termination.value.includes(opt.value),
                          )}
                          onChange={(selected) =>
                            handleChange(
                              "termination",
                              selected ? selected.map((s) => s.value) : [],
                            )
                          }
                          onBlur={() =>
                            handleOnBlur(
                              "termination",
                              letterData.termination.value,
                            )
                          }
                          styles={SELECT_CUSTOM_STYLES}
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          className={
                            letterData.termination.error ? "is-invalid" : ""
                          }
                        />

                        {letterData.termination.error && (
                          <div className="invalid-feedback d-block">
                            {letterData.termination.error}
                          </div>
                        )}
                      </FormGroup>
                    </Col>

                    <Col md="4">
                      <FormGroup>
                        <Label className="form-control-label">
                          Plug-in Termination
                        </Label>

                        <Select
                          isMulti
                          placeholder="Select plug-in termination"
                          options={getOptionsByType("PLUG_IN_TERMINATION")}
                          value={getOptionsByType("PLUG_IN_TERMINATION").filter(
                            (opt) =>
                              letterData.pluginTermination.value.includes(
                                opt.value,
                              ),
                          )}
                          onChange={(selected) =>
                            handleChange(
                              "pluginTermination",
                              selected ? selected.map((s) => s.value) : [],
                            )
                          }
                          onBlur={() =>
                            handleOnBlur(
                              "pluginTermination",
                              letterData.pluginTermination.value,
                            )
                          }
                          styles={SELECT_CUSTOM_STYLES}
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          className={
                            letterData.pluginTermination.error
                              ? "is-invalid"
                              : ""
                          }
                        />
                        {letterData.pluginTermination.error && (
                          <div className="invalid-feedback d-block">
                            {letterData.pluginTermination.error}
                          </div>
                        )}
                      </FormGroup>
                    </Col>

                    <Col md="4">
                      <FormGroup>
                        <Label className="form-control-label">Joints</Label>

                        <Select
                          isMulti
                          placeholder="Select joints"
                          options={getOptionsByType("JOINTS")}
                          value={getOptionsByType("JOINTS").filter((opt) =>
                            letterData.joints.value.includes(opt.value),
                          )}
                          onChange={(selected) =>
                            handleChange(
                              "joints",
                              selected ? selected.map((s) => s.value) : [],
                            )
                          }
                          onBlur={() =>
                            handleOnBlur("joints", letterData.joints.value)
                          }
                          styles={SELECT_CUSTOM_STYLES}
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          className={
                            letterData.joints.error ? "is-invalid" : ""
                          }
                        />

                        {letterData.joints.error && (
                          <div className="invalid-feedback d-block">
                            {letterData.joints.error}
                          </div>
                        )}
                      </FormGroup>
                    </Col>
                  </>
                )}

                {/* Tool Section */}
                {letterData.letterType.value === "TOOL_LETTER" && (
                  <>
                    <Col md="4">
                      <FormGroup>
                        <Label className="form-control-label">
                          From Location{" "}
                        </Label>
                        <Input
                          placeholder="Enter location"
                          value={letterData.fromLocation.value}
                          onChange={(e) =>
                            handleChange("fromLocation", e.target.value)
                          }
                          onBlur={(e) =>
                            handleOnBlur(e.target.name, e.target.value)
                          }
                          className={
                            letterData.fromLocation.error ? "is-invalid" : ""
                          }
                          maxLength={150}
                        />
                        {letterData.fromLocation.error && (
                          <div className="invalid-feedback d-block">
                            {letterData.fromLocation.error}
                          </div>
                        )}
                      </FormGroup>
                    </Col>

                    <Col md="4">
                      <FormGroup>
                        <Label className="form-control-label">
                          To Location
                        </Label>
                        <Input
                          placeholder="Enter location"
                          value={letterData.toLocation.value}
                          onChange={(e) =>
                            handleChange("toLocation", e.target.value)
                          }
                          onBlur={(e) =>
                            handleOnBlur(e.target.name, e.target.value)
                          }
                          className={
                            letterData.toLocation.error ? "is-invalid" : ""
                          }
                          maxLength={150}
                        />
                        {letterData.toLocation.error && (
                          <div className="invalid-feedback d-block">
                            {letterData.toLocation.error}
                          </div>
                        )}
                      </FormGroup>
                    </Col>
                  </>
                )}
              </Row>

              <div>
                <Row>
                  <Col md="10">
                    <Label className="form-control-label">
                      Jointers List
                      <InfoPopover
                        targetId="jointerList"
                        title="Jointers Information"
                        content="Enter jointer details. Government ID and Photo upload are optional."
                      />
                    </Label>
                    <Table className="jointer-table">
                      <thead>
                        <tr>
                          <th>Sr no.</th>
                          <th>
                            Jointer name{" "}
                            <span>
                              (required <span className="text-danger">*</span>)
                            </span>
                          </th>
                          {letterData.letterType.value !== "TOOL_LETTER" &&
                            letterData.letterScopeType.value !==
                            "INDIVIDUAL" && <th>Jointer type</th>}

                          {letterData.letterType.value ===
                            "AUTHORIZATION_LETTER" && (
                              <>
                                <th>Valid Govt Id</th>
                                <th>Photo</th>
                              </>
                            )}

                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {letterData.jointers.map((jointer, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>

                            <td>
                              {(() => {
                                const traineeList =
                                  traineeDataList?.data?.trainee || [];

                                return jointer.isEditing ? (
                                  <>
                                    <Select
                                      placeholder="Select Jointer"
                                      options={traineeList}
                                      classNamePrefix="react-select"
                                      getOptionLabel={(option) =>
                                        option.user?.fullName
                                      }
                                      getOptionValue={(option) => option.userID}
                                      value={jointer?.name?.value || null}
                                      onChange={(selected) =>
                                        handleJointerFieldChange(
                                          index,
                                          "name",
                                          selected || null,
                                        )
                                      }
                                      onBlur={() => handleJointerBlur(index)}
                                      className={
                                        jointer.name.error ? "is-invalid" : ""
                                      }
                                      styles={SELECT_CUSTOM_STYLES}
                                      menuPortalTarget={document.body}
                                      menuPosition="fixed"
                                    // isDisabled={letterData.letterScopeType.value !== "INDIVIDUAL" && mode === "edit" && jointer?.name?.value !== ""}
                                    />

                                    {jointer.name.error && (
                                      <div className="invalid-feedback d-block">
                                        {jointer.name.error}
                                      </div>
                                    )}
                                  </>
                                ) : (
                                  <span>
                                    {jointer?.name?.value?.user?.fullName ||
                                      "-"}
                                  </span>
                                );
                              })()}
                            </td>
                            {letterData.letterType.value !== "TOOL_LETTER" &&
                              letterData.letterScopeType.value !==
                              "INDIVIDUAL" && (
                                <td
                                  className={
                                    jointer.isEditing
                                      ? "align-start text-center"
                                      : "align-start text-center"
                                  }
                                >
                                  <div
                                    className={`d-flex align-items-center ${jointer.isEditing
                                      ? "justify-content-center"
                                      : "justify-content-start"
                                      }`}
                                  >
                                    <input
                                      type="checkbox"
                                      checked={
                                        jointer?.isSupport?.value === "YES"
                                      }
                                      disabled={letterData.natureOfWork.value.includes(6) || !jointer.isEditing} // here 6 is id of Supervision value
                                      onChange={(e) =>
                                        handleJointerFieldChange(
                                          index,
                                          "isSupport",
                                          e.target.checked ? "YES" : "NO",
                                        )
                                      }
                                    />
                                    <span className="ml-2">
                                      Supporting Role
                                    </span>
                                  </div>
                                </td>
                              )}

                            {letterData.letterType.value ===
                              "AUTHORIZATION_LETTER" && (
                                <>
                                  <td>
                                    {/* {jointer.isEditing ? (
                                      <>
                                        <Input
                                          name="governmentID"
                                          placeholder="Enter Govt-Id"
                                          value={jointer.validId.value}
                                          onChange={(e) =>
                                            handleJointerFieldChange(
                                              index,
                                              "validId",
                                              e.target.value,
                                            )
                                          }
                                          maxLength={15}
                                        />
                                        {jointer.validId.error && (
                                          <div className="invalid-feedback d-block">
                                            {jointer.validId.error}
                                          </div>
                                        )}
                                      </>
                                    ) : ( */}
                                    <span>{jointer.validId.value || "-"}</span>
                                    {/* )} */}
                                  </td>

                                  {/* Photo Upload */}
                                  <td>
                                    {/* {jointer.isEditing ? (
                                      <>
                                        <div className="d-flex align-items-center gap-3">
                                          {jointer.isEditing &&
                                            jointer.photo?.preview && (
                                              <img
                                                src={jointer.photo.preview}
                                                alt="Preview"
                                                className="edit-photo-preview"
                                              />
                                            )}

                                          <div className="custom-file flex-grow-1">
                                            <Input
                                              type="file"
                                              id={`photo_${index}`}
                                              className="custom-file-input"
                                              accept="image/*"
                                              onChange={(e) =>
                                                handleJointerFieldChange(
                                                  index,
                                                  "photo",
                                                  e.target.files[0],
                                                )
                                              }
                                            />

                                            <Label
                                              className="custom-file-label"
                                              htmlFor={`photo_${index}`}
                                            >
                                              {jointer.photo?.value?.name ||
                                                jointer.photo?.name ||
                                                "Choose file"}
                                            </Label>
                                          </div>
                                        </div>

                                        {jointer.photo.error && (
                                          <div className="invalid-feedback d-block">
                                            {jointer.photo.error}
                                          </div>
                                        )}
                                      </>
                                    ) : (
                                      <> */}
                                    {jointer.photo.preview ? (
                                      <img
                                        src={jointer.photo.preview}
                                        alt="Preview"
                                        className="jointer-photo-preview"
                                      />
                                    ) : (
                                      "-"
                                    )}
                                    {/* </>
                                    )} */}
                                  </td>
                                </>
                              )}

                            {/* Action */}
                            <td>
                              {jointer.isEditing ? (
                                <Button
                                  color="primary"
                                  size="sm"
                                  className="px-4 py-2 btn-deep-blue"
                                  onClick={() => handleSaveJointer(index)}
                                >
                                  {/* ["PROJECT_PAID","PROJECT_FREE"] condition removed on 14 Apr as per new change request */}
                                  {!isCableAccessorySelected() &&
                                    ["PROJECT_PAID"].includes(
                                      //, "PROJECT_FREE"
                                      letterData.letterScopeType.value,
                                    ) &&
                                    index === letterData.jointers.length - 1 &&
                                    letterData.jointers.length < 3
                                    ? "Add"
                                    : "Save"}
                                </Button>
                              ) : (
                                <>
                                  {letterData.letterType.value !==
                                    "TOOL_LETTER" &&
                                    letterData.letterScopeType.value !==
                                    "INDIVIDUAL" && (
                                      <>
                                        <i
                                          className="fa fa-edit text-primary mr-1 cursor"
                                          onClick={() =>
                                            handleEditJointer(index)
                                          }
                                        />
                                        <span className="mx-2 text-muted">
                                          |
                                        </span>
                                      </>
                                    )}
                                  <i
                                    className="fa fa-trash text-danger cursor"
                                    onClick={() =>
                                      handleRemoveJointer(index, jointer)
                                    }
                                  />
                                </>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </div>
              {letterData.letterType.value === "TOOL_LETTER" && (
                <>
                  <Row>
                    <Col md="10">
                      <Label className="form-control-label">Tool list</Label>
                      <Table className="mt-2 tool-table">
                        <thead>
                          <tr>
                            <th>SR No</th>
                            <th className="tool-col">
                              Item Description{" "}
                              <span>
                                (required <span className="text-danger">*</span>
                                )
                              </span>
                            </th>
                            <th className="tool-col">
                              Qty{" "}
                              <span>
                                (required <span className="text-danger">*</span>
                                )
                              </span>
                              <InfoPopover
                                targetId="toolQty"
                                title="Quantity Format"
                                content="Quantity should be in given formats only: Nos, Set, Box each, Nos each, Set each, Item, Items."
                              />
                            </th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {letterData.tools
                            .filter((tool) => !tool.isDeleted)
                            .map((tool, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>

                                {/* Description */}
                                <td className="tool-col">
                                  {tool.isEditing ? (
                                    <>
                                      <Input
                                        type="text"
                                        name="description"
                                        placeholder="Enter item description"
                                        value={tool.description.value}
                                        onChange={(e) =>
                                          handleToolChange(
                                            index,
                                            "description",
                                            e.target.value,
                                          )
                                        }
                                        onBlur={() =>
                                          handleToolBlur(index, "description")
                                        }
                                        className={`tool-input ${tool.description.error ? "is-invalid" : ""}`}
                                        maxLength={250}
                                      />
                                      {tool.description.error && (
                                        <div className="invalid-feedback d-block">
                                          {tool.description.error}
                                        </div>
                                      )}
                                    </>
                                  ) : (
                                    <span>{tool.description.value || "-"}</span>
                                  )}
                                </td>

                                {/* Qty */}
                                <td className="tool-col">
                                  {tool.isEditing ? (
                                    <>
                                      <Input
                                        type="text"
                                        name="qty"
                                        onBlur={() =>
                                          handleToolBlur(index, "qty")
                                        }
                                        placeholder="Enter item quantity eg. 1 Nos, 1 Set"
                                        value={tool.qty.value}
                                        onChange={(e) =>
                                          handleToolChange(
                                            index,
                                            "qty",
                                            e.target.value,
                                          )
                                        }
                                        className={
                                          tool.qty.error ? "is-invalid" : ""
                                        }
                                      />
                                      {tool.qty.error && (
                                        <div className="invalid-feedback d-block">
                                          {tool.qty.error}
                                        </div>
                                      )}
                                    </>
                                  ) : (
                                    <span>{tool.qty.value || "-"}</span>
                                  )}
                                </td>

                                {/* Action */}
                                <td>
                                  {tool.isEditing ? (
                                    <Button
                                      color="primary"
                                      size="sm"
                                      className="px-4 py-2 btn-deep-blue"
                                      onClick={() => handleSaveTool(index)}
                                    >
                                      {index === letterData.tools.length - 1
                                        ? "Add"
                                        : "Save"}
                                    </Button>
                                  ) : (
                                    <>
                                      <i
                                        className="fa fa-edit text-primary mr-3 cursor"
                                        onClick={() => handleEditTool(index)}
                                      />
                                      <span className="mx-2 text-muted">|</span>
                                      <i
                                        className="fa fa-trash text-danger cursor"
                                        onClick={() => handleRemoveTool(index)}
                                      />
                                    </>
                                  )}
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </Table>
                    </Col>
                  </Row>
                </>
              )}
            </Form>
          </CardBody>
          <Row className="mt-4 mr-4 mb-5">
            <Col className="text-right">
              <Button
                color="secondary"
                className="mr-2 px-4 py-2"
                type="button"
                onClick={handleOnCancel}
              >
                Cancel
              </Button>

              <Button
                color="primary"
                className="btn-deep-blue mr-2 px-4 py-2"
                type="button"
                onClick={handleOnPreview}
                disabled={showLoaderOnClick}
              >
                {showLoaderOnClick ? (
                  <i className="fa fa-spinner fa-spin" />
                ) : (
                  "Preview"
                )}
              </Button>
            </Col>
          </Row>
        </Card>
      </Container>

      <Modal
        isOpen={previewModal.isOpen}
        toggle={handleClosePreviewModal}
        size="xl"
      >
        <ModalHeader toggle={handleClosePreviewModal}>
          Letter Preview
        </ModalHeader>
        <div className="d-flex align-items-center justify-content-end mb-2 px-4">
          <Button
            color="primary"
            className="btn-deep-blue mr-2 px-4 py-2"
            type="button"
            onClick={handleRequestApproval}
            disabled={showLoaderOnClick}
          >
            {showLoaderOnClick ? (
              <i className="fa fa-spinner fa-spin" />
            ) : (
              "Request approval"
            )}
          </Button>
        </div>
        <ModalBody style={{ height: "80vh" }}>
          {previewModal.fileUrl && (
            <iframe
              src={`${previewModal.fileUrl}#toolbar=0&navpanes=0&scrollbar=0`}
              title="PDF Preview"
              width="100%"
              height="100%"
              style={{ border: "none" }}
            />
          )}
        </ModalBody>
      </Modal>
    </>
  );
}

export default LetterForm;
